<div #container class='agpr-pageBuilder' [ngClass]="styleClass">
    <gridster
        *ngIf="isGrid"
        [options]="gridsterOptions"
        class="agpr-pageBuilder-gridster"
    >
        <gridster-item
            *ngFor="let block of blocks; let i = index"
            [item]="block"
        >
            <agpr-block-wrapper
                [blockPosition]="i + ''"
                [block]="block"
                (keydown)="onKeydown($event, block)"
                [inlineAdderAdjustment]="inlineAdderAdjustment"
                [actionMenuTextAlignment]="actionMenuTextAlignment"
            ></agpr-block-wrapper>
        </gridster-item>
    </gridster>
    <ng-container *ngIf="!isGrid">
        <div
            class="agpr-pageBuilder-dropzone"
            [class.is-dragging]="isDragging"
            [dndDropzone]="['block', 'blockType']"
            dndEffectAllowed="copyMove"
            (dndDrop)="onDropBlocks($event)"
        >
            @if (showPlaceholder && (blocks?.length === 0)) {
                <div
                    class="blockPlaceholder"
                    (mouseleave)="setPlaceholder(false)"
                >
                    <label class="blockPlaceholder-header">
                        {{ 'PageBuilder.layoutBlock.placeholder.label' | localize }}
                    </label>
                    <agpr-kebab-menu
                        class="blockPlaceholder-icon"
                        [id]="'addComponentButton_moreOptions'"
                        icon="fa-regular fa-duotone fa-square-plus"
                        [panelPositionX]="panelPositions.right"
                        [options]="optionsCenter"
                        [showIcon]="true"
                        [loading]="null"
                        [panelAlignCenter]="true"
                        [textAlignment]="actionMenuTextAlignment"
                    ></agpr-kebab-menu>
                </div>
            }

            <div
                dndPlaceholderRef
                class="agpr-drag-placeholder"
            ></div>

            @for (block of blocks; track block.uniqueId) {
                <div
                    [dndDraggable]="$index"
                    dndType="block"
                    dndEffectAllowed="move"
                    [dndDisableIf]="!block.canMove || !block.actionable"
                    [dndDisableDragIf]="!block.canMove || !block.actionable || !block.draggable"
                    (dndStart)="onDragStartBlocks(block, $event)"
                    (dndEnd)="cleanupAfterDragCompleted($event)"
                >
                    <agpr-block-wrapper
                        [blockPosition]="$index + ''"
                        [block]="block"
                        [inlineAdderAdjustment]="inlineAdderAdjustment"
                        [actionMenuTextAlignment]="actionMenuTextAlignment"
                    ></agpr-block-wrapper>
                </div>
            }
        </div>
    </ng-container>
</div>
